import { Injectable } from '@angular/core';
import { LocalStorageService } from './local-storage.service';
import { NavigationService } from './navigation.service';
import { BehaviorSubject, filter, Observable } from 'rxjs';
import { ApiService } from './api.service';

@Injectable({
	providedIn: 'root',
})
export class LoggedInService {
	//starts out null then is turned to false or true depending
	//on token / local storage state.
	private isLoggedInSubject = new BehaviorSubject<boolean | null>(null);

	public isLoggedIn$: Observable<boolean> = this.isLoggedInSubject.pipe(
		filter((state: boolean | null): state is boolean => state !== null)
	) as Observable<boolean>;

	private serverLogoutInFlight = false;

	constructor(
		private localStorage: LocalStorageService,
		private nav: NavigationService,
		private api: ApiService
	) {}

	public loggedIn(): void {
		this.isLoggedInSubject.next(true);
	}

	public logout(dontNotifyServer: boolean = false): void {
		if (dontNotifyServer) {
			this.completeLocalLogout();
			return;
		}

		if (this.serverLogoutInFlight) {
			return;
		}

		this.serverLogoutInFlight = true;

		this.api.post('cognito/logout', {}).subscribe({
			next: () => {
				this.serverLogoutInFlight = false;
				this.completeLocalLogout();
			},
			error: error => {
				this.serverLogoutInFlight = false;
				console.warn('Logout cookie clear failed', error);
				this.completeLocalLogout();
			},
		});
	}

	private completeLocalLogout(): void {
		this.localStorage.clearAllAuthData();

		this.isLoggedInSubject.next(false);

		//If the path does not start with /home then redirect to root
		const doesPathStartWithHome = window.location.pathname.startsWith('/home');

		//...if we're not already there.
		const isPathAlreadyAtRoot = window.location.pathname === '/';

		if (!doesPathStartWithHome && !isPathAlreadyAtRoot) {
			this.nav.navigate(['/']);
		}
	}
}
